import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";

const state = {};

const actions = {
  async adminUpdate(_, update) {
    const url = SettingsService.settings.APIURL + `optouts/OptOut/admin`;
    const resp = await ApiService.put(url, update);
    return resp.data;
  },
  async loadConfiguration(_, planId) {
    const url =
      SettingsService.settings.APIURL + `optouts/PlanConfiguration/${planId}`;
    const resp = await ApiService.get(url);
    return resp.data;
  },
  async optOutCanBeApproved(_, optOutId) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/OptOut/optOuts/${optOutId}/canBeApproved`;
    const resp = await ApiService.get(url);
    return resp.data;
  },
  async loadPeriods(_, planId) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/periods`;
    const resp = await ApiService.get(url);
    return resp.data;
  },
  async addPeriod(_, { planId, period }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/periods`;
    const resp = await ApiService.post(url, period);
    return resp.data;
  },
  async updatePeriod(_, { planId, period }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/periods/${period.id}`;
    const resp = await ApiService.put(url, period);
    return resp.data;
  },
  async removePeriod(_, { planId, periodId }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/periods/${periodId}`;
    const resp = await ApiService.delete(url);
    return resp.data;
  },

  async loadCoverageGroups(_, planId) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/coverage-groups`;
    const resp = await ApiService.get(url);
    return resp.data;
  },

  async addCoverageGroup(_, { planId, coverageGroup }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/coverage-groups`;
    const resp = await ApiService.post(url, coverageGroup);
    return resp.data;
  },

  async updateCoverageGroup(_, { planId, coverageGroup }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/coverage-groups/${coverageGroup.id}`;
    const resp = await ApiService.put(url, coverageGroup);
    return resp.data;
  },
  async removeCoverageGroup(_, { planId, id }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/coverage-groups/${id}`;
    const resp = await ApiService.delete(url);
    return resp.data;
  },
  async loadCoverages(_, planId) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/coverages`;
    const resp = await ApiService.get(url);
    return resp.data;
  },
  async loadMemberGroups(_, planId){
    const url=SettingsService.settings.APIURL + `optouts/PlanConfiguration/${planId}/memberGroups`;
    const resp = await ApiService.get(url);
    return resp.data;
  },
  async saveConfiguration(_, configuration) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${configuration.planId}`;
    const resp = await ApiService.put(url, configuration);
    return resp.data;
  },
  async updateEmailTemplate(_, request) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${request.PlanId}/emailTemplate`;
    const resp = await ApiService.put(url, request);
    return resp.data;
  },
  async getEmailTemplate(_, { planId, status }) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${planId}/emailTemplate/${status}`;
    const resp = await ApiService.get(url);
    return resp.data;
  },
  async editConfiguration(_, configuration) {
    const url =
      SettingsService.settings.APIURL +
      `optouts/PlanConfiguration/${configuration.planId}`;
    const resp = await ApiService.put(url, configuration);
    return resp.data;
  },
  async loadOptOuts() {
    const url = SettingsService.settings.APIURL + `optouts/OptOut`;
    return await ApiService.get(url);
  },
  async updateOptOut(_, id, data) {
    const url = SettingsService.settings.APIURL + `optouts/OptOut/${id}`;
    return await ApiService.put(url, data);
  },
  async loadReimbursements(_, planId) {
    const url =
      SettingsService.settings.APIURL + `optouts/Reimbursement/${planId}`;
    return await ApiService.get(url);
  },
};

const getters = {};

const mutations = {};

export const optouts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
